module.exports = __webpack_public_path__ + "20a9c081d904e6a3c3b1120d8b3ca603.svg";